/*
 * @Description:
 * @Author: fiveonelei
 * @Date: 2022-02-24 10:47:38
 * @FilePath: /vise/packages/app-share/src/utils/mini-app.ts
 */

import { MINIAPPPATHS, EMiniAppPosition } from '@/constants/mini-app';
import { FetchShareStrategyResult } from '@/types/services/fetch-share-strategy';
import { IHashMap } from '@/types/data';

export type MiniAppPathUrlParams = {
  action?: string,
  outFrom?: number,
  spid?: string,
  feedId?: string,
  cid?: string,
  personid?: string,
  ownerid?: string,
};

export type MiniAppPathCommonParams = {
  growthTestData: FetchShareStrategyResult | null,
  query?: IHashMap,
};

export type MiniAppPathParams =  MiniAppPathUrlParams & MiniAppPathCommonParams;


const getMiniAppReportValue = function (position: EMiniAppPosition, params: MiniAppPathCommonParams) {
  const { miniAppSwitchs } = params.growthTestData || {};
  enum EReportValue {
    r0 = 0,
    r1 = 1,
    r2 = 2,
  };
  if (!params.growthTestData || !miniAppSwitchs) {
    return EReportValue.r0; // 异常，没收到开关
  }
  const v = miniAppSwitchs[position];
  if (v === null) { // 异常，没收到开关
    return EReportValue.r0;
  }
  return v === 0 ? EReportValue.r2 : EReportValue.r1;
};

const getMiniAppPath = function (position: EMiniAppPosition, params: MiniAppPathParams) {
  const { miniAppSwitchs } = params.growthTestData || {};
  if (!miniAppSwitchs || !miniAppSwitchs[position]) {
    return '';
  }
  const { query = {} } = params;
  const { spid, id, collectionid } = query;
  const newParams: IHashMap = {
    spid,
    feedId: id,
    action: params.action,
    cid: collectionid,
    outFrom: params.outFrom,
    personid: params.personid || params.ownerid,
  };
  const actionMap = new Map([
    [EMiniAppPosition.videoLike, '001'],
    [EMiniAppPosition.videoHeadpicFocus, '002'],
    [EMiniAppPosition.videoComment, '003'],
  ]);
  newParams.action = actionMap.get(position) || '';
  const outFrom = newParams.outFrom || 10002;
  const queryString = Object.keys(newParams).map(key => `${key}=${encodeURIComponent(newParams[key] || '')}`)
    .join('&');
  const path = MINIAPPPATHS[position];
  const url = `${path}?${queryString}`;
  if (path !== EMiniAppPosition.jumpWeishi) {
    return `${EMiniAppPosition.jumpWeishi}?navigateTo=${encodeURIComponent(url)}&outFrom=${outFrom}`;
  }
  return url;
};

export default {
  getMiniAppPath, getMiniAppReportValue,
};
